import create from 'zustand';
// Calling actions outside a React event handler needs to be wrapped with `unstable_batchedUpdates`
// (https://github.com/pmndrs/zustand#calling-actions-outside-a-react-event-handler)
import { unstable_batchedUpdates as unstableBatchedUpdates } from 'react-dom';

const getItemFromLocalStorage = (key: string) => {
  const item = localStorage.getItem(key);

  if (!item || item === 'undefined' || item === 'null' || item === '0') {
    return undefined;
  }
  return JSON.parse(item);
};
const setItemToLocalStorage = (key: string, value?: number) =>
  localStorage.setItem(key, JSON.stringify(value));

type State = {
  // This data only lives in the browser
  // It will be used to determine the currentSite if this siteId is accessible for this user
  preferredCurrentSiteId: number | undefined;
  setPreferredCurrentSiteId: (newPreferredCurrentSiteId?: number) => void;
};

export const useSiteStore = create<State>((set) => ({
  preferredCurrentSiteId: getItemFromLocalStorage('preferredCurrentSiteId'),
  setPreferredCurrentSiteId: (newPreferredCurrentSiteId?: number) =>
    set(() => {
      setItemToLocalStorage('preferredCurrentSiteId', newPreferredCurrentSiteId);
      return { preferredCurrentSiteId: newPreferredCurrentSiteId };
    }),
}));

// To update the preferredCurrentSiteId from angular, call this:
export const nonReactSetPreferredCurrentSiteId = (
  newPreferredCurrentSiteId: number | undefined,
): void => {
  if (newPreferredCurrentSiteId) {
    unstableBatchedUpdates(() => {
      useSiteStore.getState().setPreferredCurrentSiteId(newPreferredCurrentSiteId);
    });
  }
};

// To see all the changes happening, uncomment the next line:
// const unsub = useSiteStore.subscribe(console.log);
